import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import DataTableRepository from '../Repositories/DataTableRepository'

class DataTableBloc {

    rowtableChannel = new Subject();
    inactiveChannel = new Subject();
    inactiveSKChannel = new Subject();
    fetchexportTemplateKenaikanPangkatChannel = new Subject();
    fetchimportDataKenaikanPangkatChannel = new Subject();
    repository = new DataTableRepository()

    constructor() {
        this.rowtableChannel.next({status: apiResponse.INITIAL})
        this.inactiveChannel.next({status: apiResponse.INITIAL})
        this.inactiveSKChannel.next({status: apiResponse.INITIAL})
        this.fetchexportTemplateKenaikanPangkatChannel.next({status: apiResponse.INITIAL})
        this.fetchimportDataKenaikanPangkatChannel.next({status: apiResponse.INITIAL})
        
    }

    fetchRowTable = async (query, cancelToken) => {
        try {
            this.rowtableChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchRowTable(query, cancelToken).then((result) => {
                this.rowtableChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.rowtableChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log('unsubscribed') }
    }

    fetchInactive = async (query) => {
        try {
            this.inactiveChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchInactive(query).then((result) => {
                this.inactiveChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.inactiveChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log('unsubscribed') }
    }
    fetchInactiveSK = async (query) => {
        try {
            this.inactiveSKChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchInactiveSK(query).then((result) => {
                this.inactiveSKChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.inactiveSKChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log('unsubscribed') }
    }

    fetchexportTemplateKenaikanPangkat = async (query) => {
        try {
            this.fetchexportTemplateKenaikanPangkatChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchexportTemplateKenaikanPangkat(query).then((result) => {
                this.fetchexportTemplateKenaikanPangkatChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.fetchexportTemplateKenaikanPangkatChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log('unsubscribed') }
    }

    fetchimportDataKenaikanPangkat = async (query) => {
        try {
            this.fetchimportDataKenaikanPangkatChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchimportDataKenaikanPangkat(query).then((result) => {
                this.fetchimportDataKenaikanPangkatChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.fetchimportDataKenaikanPangkatChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) { console.log('unsubscribed') }
    }

}

export default DataTableBloc